import * as Yup from 'yup';
import { phoneExpression } from '../utility/phone-expression';


const InsuranceClaimHistorySubjectSchema = Yup.object().shape({
    insuranceClaimHistorySubject: Yup.object().shape({
        firstName: Yup.string()
            .required('Required'),
        lastName: Yup.string()
            .required('Required'),
        email: Yup.string()
            .email('Invalid email'),
        phone: Yup.string()
            .matches(phoneExpression, 'Invalid phone number'),
    })
});

export default InsuranceClaimHistorySubjectSchema;